import { AutoMap } from "@automapper/classes"

export class WorkDTO {
    @AutoMap()
    startDate!: string
    @AutoMap()
    buildingType!: number
    @AutoMap()
    buildingTypeOther: string = ''
}